import React, { useState } from 'react';
import SkusTable from '/src/Components/SkusTable/SkusTable';
import ProjectsListCard from '/src/Components/ProjectsListCard/ProjectsListCard';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import { BrickWall, MonitorPlay, ArrowLeft, Plus } from 'lucide-react';
import './style.css';

const CompanyCostCard = ({ companyName, companyIconPath, rangeLow, rangeHigh, size, onClick, isSelected }) => {
    const companyProjectsListAreRangesEqual = rangeLow === rangeHigh;

    return (
        <div className={`diy-projects-review-section-materials-buy-in-one-place-company ${isSelected ? 'selected' : ''}`} onClick={onClick}>
            <div className={`diy-projects-review-section-materials-buy-in-one-place-company-icon ${size}`}>
                <img src={CreateCloudfrontUrl(companyIconPath)} alt={companyName} />
            </div>
            <div className="diy-projects-review-section-materials-buy-in-one-place-est-cost">
                <span className={`diy-projects-review-section-materials-buy-in-one-place-est-cost-label ${size}`}>Est. Total Cost: </span>
                <span className={`diy-projects-review-section-materials-buy-in-one-place-est-cost-value ${size}`}>
                    ${companyProjectsListAreRangesEqual
                        ? rangeLow.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                        : `${rangeLow.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} - ${rangeHigh.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                </span>
            </div>
        </div>
    )
}

const DIYGuidanceMaterials = ({
    areAnyCompaniesPresentInAllProjects,
    companiesPresentInAll,
    enrichedCompanies,
    projectsDIY,
    soldByAnalysis,
    planProjectsWithDiyPreference
    // handleVendorSelect,
    // showSkuTable,
    // setShowSkuTable,
    // setSkuTableReady,
}) => {
    const [showSkuTable, setShowSkuTable] = useState(false);
    const [skuTableReady, setSkuTableReady] = useState(false);
    const [selectedProjectWithVendors, setSelectedProjectWithVendors] = useState(null);

    const areObjectsEqual = (newObj, selectedObj) => {
        if (!newObj || !selectedObj) return false;
        return newObj.vendor.id === selectedObj.vendor.id &&
            newObj.projects.length === selectedObj.projects.length &&
            newObj.projects.every(project =>
                selectedObj.projects.some(p => p.project_id === project.project_id)
            );
    };

    const handleVendorSelect = (vendor, projects) => {
        setShowSkuTable(false);
        setSkuTableReady(false);

        setTimeout(() => {
            const selectedVendorObject = enrichedCompanies.find(company => company.id === vendor.sold_by);
            const selectedVendorProjects = planProjectsWithDiyPreference.filter(project =>
                projects.includes(project.project_id)
            );

            const newObject = {
                vendor: selectedVendorObject,
                projects: selectedVendorProjects
            };

            if (!areObjectsEqual(newObject, selectedProjectWithVendors)) {
                setSelectedProjectWithVendors(newObject);
                setShowSkuTable(true);
                setSkuTableReady(true);

                // Add small delay to ensure DOM is updated before scrolling
                setTimeout(() => {
                    document.getElementById('diy-skus-review-container')?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 100);
            } else {
                setShowSkuTable(false);
                setSkuTableReady(false);
                setSelectedProjectWithVendors(null);
            }
        }, 0);
    };

    let materialsSectionIntroPart1 = ""
    if (companiesPresentInAll) {
        materialsSectionIntroPart1 = "It looks like you can actually buy the materials you'll need from a single vendor, though always check whether mixing and matching might be more cost effective. ";
    } else {
        materialsSectionIntroPart1 = "Unfortunately, it looks like you may need to buy the materials from multiple vendors. That said, we may have missed some product options and many vendors have very similar offerings. ";
    }

    const materialsSectionIntroPart2 = "Your total cost will depend on which specific product you choose, but the options shown will do the job. Click on a vendor to see the full list and print it out to take with you!"

    const materialsSectionIntro = `${materialsSectionIntroPart1} ${materialsSectionIntroPart2}`
    const buyInOnePlaceText = "One-Stop Shop";
    const buyByProjectText = "By Project";
    return (
        <div className="diy-projects-review-section-content">
            <p className="diy-projects-review-section-materials-intro text-align-center" dangerouslySetInnerHTML={{ __html: materialsSectionIntro }} />
            <div className="diy-projects-review-section-materials-container">
                {(areAnyCompaniesPresentInAllProjects && projectsDIY.length > 1) && (
                    <>
                        <div className="diy-projects-review-section-materials-buy-in-one-place-container">
                            <h2>{buyInOnePlaceText}</h2>
                            <div className="diy-projects-review-section-materials-buy-in-one-place-companies">
                                {companiesPresentInAll.map(company => {
                                    const companyId = company.sold_by;
                                    const companyIconPath = enrichedCompanies.find(c => c.id === companyId)?.icon_path;

                                    const companyProjectsList = company.present_in_list;

                                    // Get the project_id from each object in the companyProjectsList array
                                    const projectIds = companyProjectsList.map(project => project.project_id);
                                    console.log('projectIds ', projectIds);
                                    // Sum the range_low for each project, then add together across all projects
                                    const companyProjectsListRangeLowSum = companyProjectsList.reduce((sum, project) => sum + project.range_low, 0);
                                    const companyProjectsListRangeHighSum = companyProjectsList.reduce((sum, project) => sum + project.range_high, 0);
                                    const companyProjectsListAreRangesEqual = companyProjectsListRangeLowSum === companyProjectsListRangeHighSum;


                                    let isSelected = false;
                                    if ((selectedProjectWithVendors && selectedProjectWithVendors.vendor.id === companyId && selectedProjectWithVendors.projects.length > 1)) {
                                        isSelected = true;
                                    }
                                    return (
                                        <CompanyCostCard
                                            companyName={company.name}
                                            companyIconPath={companyIconPath}
                                            rangeLow={companyProjectsListRangeLowSum}
                                            rangeHigh={companyProjectsListRangeHighSum}
                                            onClick={() => handleVendorSelect(company, projectIds)}
                                            isSelected={isSelected}
                                        />
                                        // <div className="diy-projects-review-section-materials-buy-in-one-place-company">
                                        //     <div className="diy-projects-review-section-materials-buy-in-one-place-company-icon">
                                        //         <img src={CreateCloudfrontUrl(companyIconPath)} alt={company.name} />
                                        //     </div>
                                        //     <div className="diy-projects-review-section-materials-buy-in-one-place-est-cost">
                                        //         <span className="diy-projects-review-section-materials-buy-in-one-place-est-cost-label">Estimated Total Cost: </span>
                                        //         <span className="diy-projects-review-section-materials-buy-in-one-place-est-cost-value">
                                        //             ${companyProjectsListAreRangesEqual
                                        //                 ? companyProjectsListRangeLowSum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                        //                 : `${companyProjectsListRangeLowSum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} - ${companyProjectsListRangeHighSum.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                        //         </span>
                                        //     </div>
                                        // </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="vertical-divider" />
                    </>
                )}
                <div className={`diy-projects-review-section-materials-buy-by-project-container ${(!areAnyCompaniesPresentInAllProjects || projectsDIY.length === 0) ? 'no-one-stop-shop' : ''}`}>
                    {projectsDIY.length > 1 &&
                        (
                            <h2>{buyByProjectText}</h2>
                        )
                    }
                    <div className={`diy-projects-review-section-materials-buy-by-project-individual-project-container ${(!areAnyCompaniesPresentInAllProjects || projectsDIY.length === 0) ? 'no-one-stop-shop' : ''}`}>
                        {projectsDIY.map(project => {
                            // console.log('project ', project);
                            const projectId = project.project_id;
                            // Take the soldByAnalysis array, filter it based on whether or not there is an object in the present_in_list that has a project_id that matches projectId
                            const projectPresentInList = soldByAnalysis.filter(analysis => analysis.present_in_list.some(project => project.project_id === projectId));
                            return (
                                <div className={`diy-projects-review-section-materials-buy-by-project-individual-project-card ${(!areAnyCompaniesPresentInAllProjects || projectsDIY.length === 0) ? 'no-one-stop-shop' : ''}`}>
                                    <ProjectsListCard
                                        project={project}
                                        handleProjectClick={null}
                                        isSelected={null}
                                        showAllDetails={false}
                                        simulatorView={false}
                                    />
                                    <div className={`diy-projects-review-section-materials-buy-by-project-individual-project-card-vendors ${(!areAnyCompaniesPresentInAllProjects || projectsDIY.length === 0) ? 'no-one-stop-shop' : ''}`}>
                                        {projectPresentInList.map(company => {
                                            const companyId = company.sold_by;
                                            const companyIconPath = enrichedCompanies.find(c => c.id === companyId)?.icon_path;

                                            // Filter the company.present_in_list array to only include objects that have a project_id that matches projectId
                                            const companyProjectsList = company.present_in_list.filter(project => project.project_id === projectId);
                                            // Sum the range_low for each project, then add together across all projects
                                            const companyProjectsListRangeLowSum = companyProjectsList.reduce((sum, project) => sum + project.range_low, 0);
                                            const companyProjectsListRangeHighSum = companyProjectsList.reduce((sum, project) => sum + project.range_high, 0);

                                            let isSelected = false;
                                            if ((
                                                selectedProjectWithVendors &&
                                                selectedProjectWithVendors.vendor.id === companyId &&
                                                selectedProjectWithVendors.projects.length === 1 &&
                                                selectedProjectWithVendors.projects[0].project_id === projectId
                                            )) {
                                                isSelected = true;
                                            }
                                            return (
                                                <CompanyCostCard
                                                    companyName={company.name}
                                                    companyIconPath={companyIconPath}
                                                    rangeLow={companyProjectsListRangeLowSum}
                                                    rangeHigh={companyProjectsListRangeHighSum}
                                                    size="small"
                                                    onClick={() => handleVendorSelect(company, [projectId])}
                                                    isSelected={isSelected}
                                                />
                                            )
                                        })}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            {(showSkuTable && selectedProjectWithVendors) && (
                <>
                    <div className="diy-projects-curly-brace-divider-container">
                        <CurlyBraceDivider />
                    </div>
                    <div id="diy-skus-review-container" className="diy-skus-review-container">
                        {selectedProjectWithVendors.projects.map(vendorProject => (
                            <div
                                key={`${selectedProjectWithVendors.vendor.id}-${vendorProject.project_id}`}
                                className="diy-skus-review-vendor-project-container"
                            >
                                <div className="diy-skus-review-vendor-project-header-container">
                                    <div className="diy-skus-review-vendor-project-header-icon-container">
                                        <img src={CreateCloudfrontUrl(selectedProjectWithVendors.vendor.icon_path)} alt={selectedProjectWithVendors.vendor.name} />
                                    </div>
                                    <Plus strokeWidth={3.5} />
                                    <ProjectsListCard
                                        project={vendorProject}
                                        handleProjectClick={null}
                                        isSelected={true}
                                        showAllDetails={false}
                                        simulatorView={false}
                                    />
                                </div>
                                <SkusTable
                                    key={`${selectedProjectWithVendors.vendor.id}-${vendorProject.project_id}-table`}
                                    selectedVendorId={selectedProjectWithVendors.vendor.id}
                                    project={vendorProject}
                                    preEnhanced={true}
                                    inGettingItDone={true}
                                />
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}

export default DIYGuidanceMaterials;